import { atomWithReset } from 'jotai/utils'

export const filterStringAtom = atomWithReset<string>('')
